"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  oneOfFieldsIsRequired: 'Одно из полей обязательно к заполнению',
  fieldCannotBeEmpty: 'Поле не может быть пустым',
  mustBeNumber: 'Поле должно быть числом'
};